import { Card, Col } from 'react-bootstrap'
import nodata from "../../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { DashboardTable } from '../../commonDashboardComponents/DashboardTable'

export const CEOPaymentsSnap = ({ data }) => {
    const paymentCardData = data && data.map(c => ({
        paymentNumber: c.payment_number,
        invoiceOrderNumber: c.invoice_number,
        paymentMode: c.payment_mode,
        amountReceived: c.amount_recevied
    }))
    // background: none won't apply since an !important is needed to override the default background color
    // a class should be created for the table header to apply background: none!important

    // the table should be responsive currently the table data overflows outside the card body and even after implementation i don't want a scrollbar for horizontal overflow
    const paymentTableHeader = () => (<thead style={{ zIndex: 10 }}>
        <tr style={{ textAlign: "start" }}>
            <th scope="col" className='d-table-cell tableHeader ' style={{ fontSize: '12px' }}>
                Payment Number
            </th>
            <th scope="col" className='d-table-cell tableHeader ' style={{ fontSize: '12px' }}>
                Invoice Order Number
            </th>
            <th scope="col" className='d-table-cell tableHeader ' style={{ fontSize: '12px' }}>
                Payment Mode
            </th>
            <th scope="col" className='d-table-cell tableHeader ' style={{ fontSize: '12px' }}>
                Amount Received
            </th>
        </tr>
    </thead>
    )

    const paymentTableBody = () => (
        paymentCardData.map((payment, idx) => (
            <tr key={idx}>
                <td className="fw-semibold text-dark">{payment.paymentNumber}</td>
                <td className="text-muted">{payment.invoiceOrderNumber}</td>
                <td className="text-muted">{payment.paymentMode}</td>
                <td className="fw-semibold text-dark">{payment.amountReceived}</td>
            </tr>
        ))
    )
    return (
        <Col lg={5}>
            <DashboardTable
                title={"Payment Received"}
                subheader={"A snapshot of today's payments."}
                tableHeader={paymentTableHeader}
                tableBody={paymentTableBody}
                dataLength={data ? data?.length : 0}
            />
        </Col>
    )
}
